import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Asset } from '@app/core/model/entities/asset/asset';
import {
  OrganizationCheckCreateModalComponent
} from '@app/features/main/views/organization-checks/modals/organization-check-create-modal/organization-check-create-modal.component';

@Component({
  templateUrl: './check-create-modal.component.html',
  styleUrls: ['./check-create-modal.component.scss'],
  standalone: false
})
export class CheckCreateModalComponent extends OrganizationCheckCreateModalComponent implements OnInit {
  private readonly asset = inject<{ asset: Asset }>(MAT_DIALOG_DATA).asset;

  /**
   * Set initial Asset value so Spaces can be loaded.
   */
  public ngOnInit(): void {
    super.ngOnInit();
    this.checkSpaceForm.controls.asset.setValue(this.asset.toRelatedAsset());
  }
}
